import getApiClient from 'src/utils/getApiClient'
import type { ApiDoctorsParamsGet, ApiDoctorsResponseGet } from 'src/components/pages/memorial/MemoryBoardPage/api/apiDoctors.type'

const apiClient = getApiClient()

export default {
  get(params: ApiDoctorsParamsGet = {}) {
    return apiClient.get<ApiDoctorsResponseGet>('/api/memorial/doctors/', { params })
  },
}
